import { render, staticRenderFns } from "./AddEmployeeSalary.vue?vue&type=template&id=28129846&scoped=true&"
import script from "./AddEmployeeSalary.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeSalary.vue?vue&type=script&lang=js&"
import style0 from "./AddEmployeeSalary.vue?vue&type=style&index=0&id=28129846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28129846",
  null
  
)

export default component.exports